import { Component, Input } from '@angular/core';
import { faArrowUp, faArrowDown, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-dicount-icon',
  templateUrl: './dicount-icon.component.html',
  styleUrl: './dicount-icon.component.scss'
})
export class DicountIconComponent {
  public icons = {
    faArrowUp,
    faArrowDown
  }
  
  @Input() discount: number = 0;
  @Input() receivedAs: string = 'percetage';

  public discountToShow: number = 0;
  public type: string = '';
  public iconToDisplay: IconDefinition | null = null;
  public styling = {}

  constructor() { }

  ngOnInit(): void {
    const actualDiscount = this.receivedAs === 'percetage' ? this.discount : this.discount * 100;

    this.discountToShow = Math.abs(actualDiscount);
    if(actualDiscount === 0) return;
    this.type = actualDiscount > 0 ? 'Descuento' : 'Aumento';
    this.iconToDisplay = actualDiscount > 0 ? this.icons.faArrowDown : this.icons.faArrowUp;
    this.styling = {
      color: actualDiscount > 0 ? 'red' : 'green',
    }
  }

}
